exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-inner[data-v-263b6cde] {\n  margin: 0 auto;\n  max-width: 321px;\n}\n.modal-title[data-v-263b6cde] {\n  margin-bottom: 6px;\n  color: #1e2541;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 24px;\n  text-align: center;\n}\n@media (max-width: 767px) {\n.modal-title[data-v-263b6cde] {\n    font-size: 24px;\n    line-height: 1;\n}\n}\n.modal-description[data-v-263b6cde] {\n  margin-bottom: 5px;\n  color: #1e2541;\n  line-height: 19px;\n  text-align: center;\n}\n.modal-icon[data-v-263b6cde] {\n  display: block;\n  margin: 0 auto 45px;\n}\n[data-v-263b6cde] .button {\n  width: 100%;\n}\n", ""]);

// exports
